import { defineStore } from 'pinia'
import type { Product, ProductCatalog } from '~/types/product'
import type { ServerListResponse } from '~/types/api/response.types'
import type { OfferCatalog } from '~/types/offer'

interface State {
  productsList: ProductCatalog[]
}

export const useCommonLatestProductsStore = defineStore('commonLatestProducts', {
  state: (): State => ({
    productsList: []
  }),
  actions: {
    async getLatestProducts() {
      return new Promise((resolve, reject) => {
        const { $api } = useNuxtApp()

        $api<ServerListResponse<ProductCatalog>>('/api/catalog/products/latest/')
          .then(({ results }) => {
            this.productsList = [...results, ...this.productsList].filter(
              (value, index, self) => {
                return (
                  self.findIndex((selfValue) => selfValue.uuid === value.uuid) === index
                )
              }
            )

            resolve(results)
          })
          .catch(reject)
      })
    },

    // в переглянуті товари записуєтся найкращий офер товара(не береться до уваги на який офер товару ти зайшов)
    addProductOffer(payload: { offer: OfferCatalog, rootProduct: Product | null }) {
      const { offer, rootProduct } = payload

      if (
        rootProduct &&
        !~this.productsList.findIndex(
          (product) => product.uuid === rootProduct.uuid
        )
      ) {
        const latestProduct = {
          offer_main: offer,
          uuid: rootProduct.uuid,
          name: rootProduct.name,
          slug: rootProduct.slug,
          rating: rootProduct.rating,
          reviews_count: rootProduct.reviews_count,
          images: rootProduct.images,
          attrs_main: rootProduct.attrs_main,
          label: rootProduct.label,
          category: rootProduct.category,
          brand: rootProduct.brand,
          p_code: rootProduct.p_code,
          model: rootProduct.model,
          code: offer.code,
          type: rootProduct.type
        }

        this.productsList = [latestProduct, ...this.productsList]
      }
    }
  }
})
